<template lang="pug">
    .box
        .post-image(v-if="image" ref="container")
            img.object-cover.object-center.h-full.w-full(
              v-lazy="image"
              rel="noopener"              
          )
        h3.name(v-if="panel.title") {{panel.title}}
        div.sub(v-if="panel.sub_title") {{panel.sub_title}}       
        div.info(v-if="panel.text" v-html="panel.text")
        

</template>

<script>
import { get, trim, startsWith } from '@/helpers';

export default {
    name: 'Panel',
    mounted() {
        if (this.id) {
            const state = this.getCollapseState();
            if (state) {
                this.isCollapsed = state[this.id];
            }
        }
    },
    data() {
        return {
            delay: 150,
            mouseover: false,
            isCollapsed: true,
            width: 320,
            height: 320
        };
    },
    props: {
        panel: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        maxWidth: {
            type: Number
        }
    },
    computed: {
        image() {
            const image = get(this.panel, 'images.0');
            if (!image) return false;

            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1';
            const parameters = {
                // ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups')
            };
            let { w, h } = parameters;
            // let { width, height } = image;
            let aspectRatio = 2 / 3;

            console.log(image);

            if (w && h) {
                h = 400;
                w = h * aspectRatio;
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${w}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${h}`);
            } else if (!w && !h) {
                h = 400;
                w = h * aspectRatio;
                fit += `&h=${h}&w=${w}`;
            }

            return {
                h,
                w,
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`
            };
        },

        hyperlink() {
            return get(this.panel, 'hyperlink') || {};
        },
        href() {
            let href = false;

            if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href;
                switch (this.hyperlink.type) {
                    case 'external':
                        if (!startsWith(link, 'https://') && !startsWith(link, 'http://')) href = `https://${link}`;
                        else href = link;
                        break;

                    case 'mailto':
                        href = `mailto:${link}`;
                        break;

                    case 'tel':
                        href = `tel:${link}`;
                        break;
                }
            }

            return href;
        },
        target() {
            return get(this.hyperlink, 'target') || '_self';
        },
        path() {
            if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
                return this.hyperlink.menuItem.path;
            else return false;
        },
        odd() {
            return this.index % 2 == 0;
        }
    },
    methods: {
        hover() {
            this.$emit('focus', this.item);
            this.mouseover = true;
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item);
                this.mouseover = false;
            }, this.delay);
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"
.box
  @apply text-sm
  @screen lg
    @apply text-base

  ::v-deep a
    @apply transition duration-500 ease-in-out
    &:hover
      color: $cc-green

  .post-image
    @apply rounded-lg overflow-hidden
    height: auto
  .name
    @apply text-base font-semibold mb-0 mt-3
    font-family: $font
    @screen lg
      @apply text-lg

  .sub
    @apply font-normal mb-3
</style>
